/* BIONIKA adatkezelési jelzés (süti-hozzájárulás) — saját kártya a Shopify
   beépített bannere helyett. A döntést a Shopify Customer Privacy API tárolja,
   így a Shopify-pixelek (GA4, Meta, appok) ugyanúgy tiszteletben tartják, mint a
   gyári bannernél. API: https://shopify.dev/docs/api/customer-privacy

   Fontos: a gyári bannert a Shopify adminban kell kikapcsolni (Beállítások →
   Vásárlói adatvédelem → Cookie banner); a CSS csak biztonsági hálóként rejti el.

   A fájlnév szándékosan semleges: a „cookie-consent" mintát a reklámblokkolók
   hálózati szinten eldobják (lásd a CSS fejlécét). */
(function () {
  var el = document.querySelector('[data-bnk-pn]');
  if (!el || el.hasAttribute('data-bnk-pn-init')) return;
  el.setAttribute('data-bnk-pn-init', '1');

  var ALL  = { analytics: true,  marketing: true,  preferences: true,  sale_of_data: true  };
  var NONE = { analytics: false, marketing: false, preferences: false, sale_of_data: false };

  function api() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  // Ha a stíluslapot valami (blokkoló, hálózati hiba) megette, NE mutassuk meg a
  // kártyát: stílus nélkül egy formázatlan szövegblokk ülne az oldal alján.
  function styled() {
    var probe = document.createElement('div');
    probe.className = 'bnk-pn';
    probe.style.visibility = 'hidden';
    document.body.appendChild(probe);
    var ok = getComputedStyle(probe).position === 'fixed';
    probe.remove();
    return ok;
  }

  function show() {
    if (!styled()) return;
    el.hidden = false;
    // Két képkocka: az `is-in` csak azután kerül fel, hogy a böngésző a kezdő
    // (áttetsző, eltolt) állapotot már kirajzolta — különben nincs átmenet.
    // A setTimeout a biztosíték: háttérben lévő fülön a rAF fel van függesztve,
    // enélkül a kártya ott láthatatlan maradna (mérve: opacity 0-n ragadt).
    var reveal = function () { el.classList.add('is-in'); };
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    setTimeout(reveal, 60);
  }

  function hide() {
    el.classList.remove('is-in');
    setTimeout(function () { el.hidden = true; }, 300);
  }

  // ---- Saját emlékezet (BIONIKA, 2026-09-01) ----------------------------------
  // A döntést NEM bízzuk kizárólag a Shopify tárolására: ha a setTrackingConsent
  // hívás elakad (blokkolt hálózat, még fel nem állt API, régió-beállítás), a
  // shouldShowBanner() a KÖVETKEZŐ oldalon újra igazat ad, és a kártya megint
  // felugrik — pontosan ezt mérte a munkamenet-visszajátszás. Ezért a döntést
  // saját cookie-ban is rögzítjük (localStorage csak tartalék: privát ablakban
  // vagy blokkolt tárolásnál dob).
  var MEM_KEY = 'bnk_pn_v1';
  var MEM_DAYS = 180;

  function remember(value) {
    try {
      var d = new Date(Date.now() + MEM_DAYS * 864e5);
      document.cookie = MEM_KEY + '=' + value + ';path=/;max-age=' + (MEM_DAYS * 86400) +
                        ';expires=' + d.toUTCString() + ';samesite=lax' +
                        (location.protocol === 'https:' ? ';secure' : '');
    } catch (e) {}
    try { localStorage.setItem(MEM_KEY, value); } catch (e) {}
  }

  function remembered() {
    if (new RegExp('(?:^|;\s*)' + MEM_KEY + '=').test(document.cookie)) return true;
    try { return !!localStorage.getItem(MEM_KEY); } catch (e) { return false; }
  }

  function decide(consent) {
    var cp = api();
    remember(consent.analytics ? 'all' : 'necessary');
    if (cp && typeof cp.setTrackingConsent === 'function') {
      // Ha a Shopify-oldali mentés hibázik, egy második próbát még teszünk — a saját
      // emlékezet miatt a kártya akkor sem jön vissza, de a pixelek így követik a döntést.
      cp.setTrackingConsent(consent, function (res) {
        if (res && res.error) { try { cp.setTrackingConsent(consent, function () {}); } catch (e) {} }
      });
    }
    hide();
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-bnk-pn-accept]'))  { decide(ALL);  return; }
    if (e.target.closest('[data-bnk-pn-decline]')) { decide(NONE); return; }
  });

  // A lábléc (vagy bármely) „Süti-beállítások" linkje újra előhozza a kártyát.
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bnk-privacy-open]');
    if (!opener) return;
    e.preventDefault();
    show();
  });

  // A márkaválasztó érkezési modálja fontosabb: amíg nyitva van, a süti-kártya vár.
  // Egyrészt nem takarja ki, másrészt a picker MINDEN rajta kívüli kattintásra
  // becsukódik — a kártya gombja is becsukná, mielőtt a látogató rendszert választ.
  function pickerModalOpen() {
    return !!document.querySelector('.mp-wrap--modal.mp-wrap--open');
  }

  function showWhenFree(tries) {
    if (!pickerModalOpen()) { show(); return; }
    if (tries > 0) setTimeout(function () { showWhenFree(tries - 1); }, 400);
  }

  function start() {
    var cp = api();
    if (!cp) return;
    if (remembered()) return;   // ebben a böngészőben már döntött
    // A shouldShowBanner() a bolt adatvédelmi beállításai (régió, korábbi döntés)
    // alapján dönt — így ott és akkor kérünk hozzájárulást, ahol a gyári banner is.
    try {
      if (typeof cp.shouldShowBanner !== 'function' || cp.shouldShowBanner()) showWhenFree(750); // ~5 perc türelem
    } catch (err) { /* az API még nem állt fel → nem erőltetjük */ }
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) start();
    });
  }
})();
